import React from "react"

import styles from "./Media.module.scss"
import Heading from "../../../../components/shared/Heading";
import PlayIcon from "../../../../components/icons/details/PlayIcon";
import DotsLoader from "../../../../components/icons/DotsLoader";
import {useGetCurrentVideoQuery} from "../../../../store/api/filmAPI";
import {languageHandler} from "../../../../utils/helpers";
import {useTranslation} from "react-i18next";

type Props = {
  sectionTitle: string
  item: any
  setOpenModal: any
  activeTab: any
  setActiveTab: any,
  setSelectedMedia: any
}

const Media = ({
   sectionTitle,
   item,
   setOpenModal,
   activeTab,
   setActiveTab,
   setSelectedMedia
}: Props) => {
  const { i18n } = useTranslation();

  const { data, isLoading } = useGetCurrentVideoQuery({
      queries: { language: languageHandler(i18n.language) },
      id: item.id
    }
  );

  if (isLoading) {
    return <DotsLoader />
  }

  return (
    <div className={styles.wrapper}>
      <Heading
        title={sectionTitle}
        setActiveTab={setActiveTab}
        activeTab={activeTab}
        counter={data?.results.length}
        videosCounter={data?.results.length}
      />
      <div id={'mediaWrapper'} className={styles.cardWrapper}>
        {data?.results.map((video: any, index: number) => (
          <div
            className={styles.imgWrapper}
            onClick={() => {
              setSelectedMedia(video.key)
              setOpenModal(true)
            }}
            key={index}
          >
            <div
              className={styles.image}
              style={{backgroundImage: `url(https://i.ytimg.com/vi/${video?.key}/hqdefault.jpg)`}}
            />
            <div className={styles.playIcon}><PlayIcon extraClass={styles.pathClass}/></div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Media
